import React from 'react';
import { ServicesGrid } from '../components/ServicesGrid';
export function Services() {
  return <div className="bg-white" data-id="element-321">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20" data-id="element-322">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8" data-id="element-323">
          Clinical Services
        </h1>
        <p className="text-lg text-slate-600 mb-4 max-w-3xl" data-id="element-324">
          Professional healthcare services provided by our certified
          pharmacists.
        </p>
      </div>
      <ServicesGrid data-id="element-325" />
    </div>;
}